import Repository from './repository';

const resource = '/agent';
export default {
	all() {
		return Repository.getWithAuth(`${resource}/all`);
	},
	findLinkedAgentMerchant(payload) {
		return Repository.postWithAuth(`${resource}/merchant/find`, payload);
	},
	findLinkedAgentMerchantByAgentID(payload) {
		return Repository.postWithAuth(`${resource}/merchant/agent/find`, payload);
	},
	updateAgentNotification(payload) {
		return Repository.putWithAuth(`${resource}/merchant/notify`, payload);
	},
	linkAgentToMerchant(payload) {
		return Repository.postWithAuth(
			`${resource}/merchant/link`,
			payload,
			{},
			{ noCache: true }
		);
	},
	unlinkAgentFromMerchant(payload) {
		return Repository.putWithAuth(
			`${resource}/merchant/unlink`,
			payload,
			{},
			{ noCache: true }
		);
	},
};
